import {Component, Input, OnInit} from '@angular/core';
import {PropertyUploadsModel} from '../../models/uploads/property-uploads.models';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss']
})
export class ImageSliderComponent {
  @Input() showNavigation = false;
  @Input() showPagination = false;
  @Input() thumbnailSize = 'medium';
  @Input() images: PropertyUploadsModel[] = [];

  randomSliderId: number;

  constructor() {
    this.randomSliderId = Math.floor(Math.random() * Math.floor(999));
  }

  showSlider(): boolean {
    return Boolean(this.images?.length > 0);
  }

}
